import ProductService from "../services/productService";

export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILED = "GET_PRODUCTS_FAILED";
export const GET_PRODUCT_BY_UNIQUE_ID_SUCCESS =
  "GET_PRODUCT_BY_UNIQUE_ID_SUCCESS";
export const GET_PRODUCT_BY_UNIQUE_ID_FAILED =
  "GET_PRODUCT_BY_UNIQUE_ID_FAILED";
export const CLEAR_PRODUCT = "CLEAR_PRODUCT";

export const getProductByUniqueId = (uniqueId) => {
  return (dispatch) => {
    dispatch({ type: CLEAR_PRODUCT }); // ⭐ reset old product immediately

    ProductService.getProductByUniqueId(uniqueId)
      .then((res) => {
        dispatch({
          type: GET_PRODUCT_BY_UNIQUE_ID_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_PRODUCT_BY_UNIQUE_ID_FAILED,
          payload: err,
        });
      });
  };
};

export const getProducts = () => {
  return (dispatch) => {
    ProductService.getAllPublicProducts()
      .then((res) => {
        dispatch({
          type: GET_PRODUCTS_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_PRODUCTS_FAILED,
          payload: err,
        });
      });
  };
};
